
import { Component, Prop, Vue } from 'vue-property-decorator'
import CloseCrossCtrl from '~/components/common/ctrls/CloseCrossCtrl.vue'

@Component({
  components: {
    CloseCrossCtrl
  }
})
export default class ModalWrapper extends Vue {
  @Prop({ type: Boolean, default: true }) showCloseCtrl: boolean
}
